import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {Amount} from "../../../open-api-generated/models/amount";
import {ClientsService} from "../../../services/clients/clients.service";

@Component({
  selector: 'search-client-select',
  templateUrl: './search-client-select.component.html',
  styleUrls: ['./search-client-select.component.scss']
})
export class SearchClientSelectComponent implements OnInit {
  @Input('clientId') clientId = null;
  @Input('isCreatingForm') isCreatingForm: boolean = true;
  @Output('onClientChangedEvent') onClientChangedEvent: EventEmitter<number> = new EventEmitter<number>;

  clientName: string  = null;

  clients = [];

  constructor(
    private clientsService: ClientsService
  ) {
  }


  touched() {

  }

  ngOnInit(): void {
    if (false === this.isCreatingForm) {
      this.completeData();
    }
  }

  completeData(): void {
    if (null === this.clientId) {
      setTimeout(
        (): void => {
          this.completeData();
        }, 10
      );

      return;
    }

    this.clientsService.getClient(this.clientId).subscribe(
      (client: any) => {
        this.clientName = client.name;
      }
    );
  }

  searchClient(input): void {
    if (3 > input.value.length) {
      return;
    }

    this.clientsService.searchClient(input.value).subscribe(
      (response: Array<any>) => {
        this.clients = response;
      }
    );
  }

  setClient(client): void {
    this.clientName = client.name;
    this.clientId = client.id;
    this.clients = [];
    this.onClientChangedEvent.emit(this.clientId);
  }
}
